export default {"src":"/_next/static/media/whatsapp_icon.8e7db0da.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};